// exported here to allow mocking in tests
export default () => new Date(Date.now());
